module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./SelectOrdersView.js"));
	}, "AfterSaleSelectOrdersView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleSelectOrdersView!./src/pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/SelectOrders/SelectOrdersView.js
// module id = 1051
// module chunks = 431